import React from 'react'

function ShelfPlaceholder () {
  return <div className="shelf-placeholder" />
}

export default ShelfPlaceholder
